import { defaultClient } from 'shared/constants';
import statusCodes from 'constants/statusCodes';
import { DEFAULT_CONFIG_FLAGS } from 'shared/constants/configFlags';
import { AppState } from './types';

export const defaultState: AppState = {
  pathname: '',
  pageType: null,
  statusCode: statusCodes.SUCCESS,
  storeId: '',
  configFlagsFetched: false,
  configFlags: DEFAULT_CONFIG_FLAGS,
  run: 100,
  client: defaultClient,
  showSignUp: false,
  isTruecallerStatusFetching: false,
  showProfile: false,
  backToTopPosition: 50,
  showCartNudge: false,
  cartNudgePosition: 0,
  isLoginAutoTriggered: false,
};

export const ERROR_FETCHING_BREADCRUMBS = 'Error fetching breadcrumbs';
